import { Logo } from "@/components/Logo";

export function Footer() {
  return (
    <footer className="border-t border-hairline">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-5 py-10 sm:px-8 md:flex-row">
        <div className="flex items-center gap-3">
          <Logo className="h-7 w-7" />
          <span className="font-display text-sm font-extrabold tracking-[-0.01em] text-ink">
            SYSTECH AQUA SOLUTIONS
          </span>
        </div>
        <p className="font-mono text-[11px] tracking-[0.15em] text-ink/45">
          © {new Date().getFullYear()} SYSTECH AQUA SOLUTIONS
        </p>
        <p className="flex items-center gap-2 font-mono text-[11px] tracking-[0.15em] text-ink/60">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-signal" />
          ALL SYSTEMS OPERATIONAL
        </p>
      </div>
    </footer>
  );
}
